// CustomerTrackingPage.jsx
import React, { useState, useEffect } from 'react';
import LiveRouteMap from './LiveRouteMap';
import { api } from './services/api';
import 'leaflet/dist/leaflet.css';

const CustomerTrackingPage = () => {
  const [routeData, setRouteData] = useState(null);
  const [customerName, setCustomerName] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');

    if (!token) {
      setError('No tracking link provided.');
      setLoading(false);
      return;
    }

    api.get(`/api/TrackingToken/${token}`)
      .then(({ data }) => {
        setRouteData(data.routeData);
        setCustomerName(data.customer || data.routeData?.customer || '');
      })
      .catch((err) => {
        const msg = err.response?.data?.message;
        setError(msg || 'Invalid or expired tracking link.');
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div>;
  if (error)   return <div style={{ textAlign: 'center', padding: '40px', color: '#e74c3c' }}>{error}</div>;
  if (!routeData) return <div style={{ textAlign: 'center', padding: '40px' }}>No route data found.</div>;

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto', height: '90vh' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>📦 Live Tracking for {customerName}</h2>
      <div style={{ height: '80vh', width: '100%' }}>
        <LiveRouteMap routes={[routeData]} isCustomerView={true} />
      </div>
    </div>
  );
};

export default CustomerTrackingPage;
